<template>
  <b-card class="exam-card-item transition p-4" no-body style="border-radius: 10px; transition: transform 0.3s, box-shadow 0.3s;" 
          @mouseover="hover = true" @mouseleave="hover = false" 
          :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)', boxShadow: hover ? '0 4px 20px rgba(0, 0, 0, 0.1)' : '0 2px 8px rgba(0, 0, 0, 0.05)' }">
    <b-row align-h="between" class="mb-3">
      <b-col>
        <p class="text-primary mb-1 h5">
          {{ item.title }}
        </p>
        <p class="text-muted small mb-0">
          {{ item.description || 'No description available' }}
        </p>
      </b-col>
      <b-col cols="auto" class="text-right">
        <b-badge v-if="access_type === 'candidate'" :variant="getExamStatusVariant(item)" class="font-weight-bold px-3 py-2">
          {{ item.application_exam.score || 0 }} / {{  item.total_points || 0 }} Points
        </b-badge>
        <b-badge v-else :variant="getExamStatusVariant(item)" class="font-weight-bold px-3 py-2 mr-2">
          {{ item.total_points || 0 }} Points
        </b-badge>
        <b-badge :variant="getExamStatusVariant(item)" class="font-weight-bold px-3 py-2">
          {{ item.status }}
        </b-badge>
      </b-col>
    </b-row>

    <!-- Schedule and Details -->
    <b-row class="mb-3">
      <b-col>
        <div class="text-muted small">
          <b-icon-calendar class="mr-1"></b-icon-calendar>
          Schedule: {{ formattedSchedule(item) }}
        </div>
      </b-col>
      <b-col cols="auto" class="text-right">
        <span class="text-dark font-weight-bold">
          Duration: {{ item.duration || 'N/A' }}
        </span>
      </b-col>
    </b-row>

    <!-- Actions -->
    <b-row align-h="between">
      <b-col>
        <!-- <b-button size="sm" :variant="item.status === 'Open' ? 'primary' : 'secondary'" :disabled="item.status !== 'Open'">
          {{ item.status === 'Open' ? 'Take Exam' : 'Closed' }}
        </b-button> -->
        <b-button
          v-if="access_type === 'candidate'"
          size="sm"
          :variant="getExamStatusVariant(item)"
          :disabled="!isExamScheduledToday || (isExamScheduledToday && !isExamTimeStarted) || isExamTimeEnded || (item.status !== 'In Progress' && item.exam_taken)"
          :to="{ name: 'TakeExamPage', params: { id: item._id, application_exam: item.application_exam?._id } }"
        >
          {{ item.status === 'Not Started' ? 'Take Exam' : item.status == 'In Progress' ? 'Continue' : 'Done' }}
        </b-button>
        <b-button size="sm" variant="link" class="text-infoj" @click="viewExamDetails(item)">
          View Details
        </b-button>
      </b-col>
      <b-col cols="auto">
        <span v-if="item.attempts_remaining > 0" class="text-muted small">
          Attempts Remaining: {{ item.attempts_remaining }}
        </span>
      </b-col>
    </b-row>

    <ExamDetailsModal :exam="selectedExam" ref="examModal" />
  </b-card>
</template>


<script>
// import SettingsBtn from './SettingsBtn.vue';
import ExamDetailsModal from './ExamDetailsModal.vue';
export default {
  components: {
    // SettingsBtn,
    ExamDetailsModal
  },
  props: {
    item: Object,
    access_type: String,
  },
  computed: {
    formattedSalary() {
      return (item) => {
        const minSalary = (item.min_salary ? item.min_salary.$numberDecimal : 0) || 0;
        const maxSalary = (item.max_salary ? item.max_salary.$numberDecimal : 0) || 0;
        return `${minSalary | item.currency_id.symbol} - ${maxSalary | item.currency_id.symbol}`;
      };
    },
    isExamScheduledToday() {
      if (this.item.application_exam.date) {
        const today = new Date();
        const examDate = new Date(this.item.application_exam.date);
        return today.toDateString() === examDate.toDateString();
      }
      return false;
    },
    isExamTimeStarted() {
      const startTimeStr = this.item.application_exam.start_time;
      if (!startTimeStr) return false;

      const [hours, minutes, seconds] = startTimeStr.split(':').map(Number);

      const now = new Date();
      const manilaTime = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Manila" })
      );

      const startTimeToday = new Date(manilaTime);
      startTimeToday.setHours(hours, minutes, seconds, 0);

      return manilaTime >= startTimeToday;
    },
    isExamTimeEnded() {
      const endTimeStr = this.item.application_exam.end_time;
      if (!endTimeStr) return false;

      const [hours, minutes, seconds] = endTimeStr.split(':').map(Number);

      const now = new Date();
      const manilaTime = new Date(
        now.toLocaleString("en-US", { timeZone: "Asia/Manila" })
      );

      const endTimeToday = new Date(manilaTime);
      endTimeToday.setHours(hours, minutes, seconds, 0);

      return manilaTime >= endTimeToday;
    },
    todaysDate() {
      const today = new Date();
      return today.toLocaleDateString(undefined, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    todaysTime() {
      const today = new Date();
      return today.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
  data() {
    return {
      hover: false,
      selectedExam: null
    }
  },
  methods: {
    getExamStatusVariant(item) {
      return item.status === "Not Started"
      ? "primary"
      : item.status === "In Progress"
      ? "warning"
      : item.status === "Submitted"
      ? "success"
      : item.status === "Essay Grading in Progress"
      ? "info"
      : "secondary";
    },
    formattedSchedule(item) {
      if (item.schedule_start && item.schedule_end) {
        return `${item.schedule_start} - ${item.schedule_end}`;
      }
      return "Not Scheduled";
    },
    viewExamDetails(exam) {
      // Placeholder for viewing exam details logic
      // console.log("View Exam Details:", exam);
      this.selectedExam = exam;
      this.$refs.examModal.show();
    },
    showCompanyButton() {
      return !this.companyID && this.hasRole('company.view');
    },
    showGenerateUrl() {
      return this.hasRole('job.generate_url');
    },
    canGenerateUrl(item) {
      return !item.job_url && this.hasRole('job.generate_url') && !this.companyID;
    },
    canCopyUrl(item) {
      return item.job_url && this.hasRole('job.generate_url') && this.companyID;
    },
    canGenerateCompanyUrl(item) {
      return !item.job_company_url && this.hasRole('job.generate_url');
    },
    generateUrlText() {
      return !this.companyID ? 'Generate Company URL' : 'Generate URL';
    },
    canSubmitCandidate(item) {
      return item.active && (item.slots - item.hired) > 0 && this.hasRole('job.submit_candidate');
    },
    canActivateDeactivate() {
      return this.user.role.role == 'administration' && this.hasRole('job.activate');
    },
    canPost() {
      return this.hasRole('job.post');
    },
    canEdit(item) {
      return this.user.role.role == 'administration' && !item.published;
    },
    canViewJob() {
      return this.hasRole('job.view');
    },
    hasRole(value) {
      return this.role_modules.some(role => role.value === value);
    },
    isDraft(item) {
      return !item.published && !item.posted;
    },
    isUnposted(item) {
      return !item.published && item.posted;
    },
    showDropdownButton(item) {
      return item.hasDropdownBtn;
    },
    formatDateTime(dateTime) {
      const options = {
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date(dateTime).toLocaleString(undefined, options);
    },
    formattedTime(time) {
      const [hours, minutes, seconds] = time.split(":");
      const date = new Date();
      date.setHours(hours, minutes, seconds);
      return date.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  }
};
</script>

<style scoped>
/* Add styles here */
</style>
